import { render, staticRenderFns } from "./aboutInvestBanner.vue?vue&type=template&id=5a590be4&scoped=true&"
import script from "./aboutInvestBanner.vue?vue&type=script&lang=js&"
export * from "./aboutInvestBanner.vue?vue&type=script&lang=js&"
import style1 from "./aboutInvestBanner.vue?vue&type=style&index=1&id=5a590be4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a590be4",
  null
  
)

export default component.exports